<template>
  <div class="horizontal-divider"></div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.horizontal-divider {
  width: 100%;
  border-bottom: 1px solid #E4E4E7;
  margin: 16px 0;
}
</style>
